var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconClosePanel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_753_1078",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_753_1078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.25 12.75C7.0375 12.75 6.85942 12.6781 6.71575 12.5342C6.57192 12.3904 6.5 12.2122 6.5 11.9997C6.5 11.7871 6.57192 11.609 6.71575 11.4655C6.85942 11.3218 7.0375 11.25 7.25 11.25H16.75C16.9625 11.25 17.1406 11.3219 17.2843 11.4658C17.4281 11.6096 17.5 11.7878 17.5 12.0003C17.5 12.2129 17.4281 12.391 17.2843 12.5345C17.1406 12.6782 16.9625 12.75 16.75 12.75H7.25Z",
    fill: "#FAFAFA"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClosePanel);
export default __webpack_public_path__ + "static/media/iconClosePanel.2b76a44c597c3e65bc95544a7597f670.svg";
export { ForwardRef as ReactComponent };